import Breadcrumb from "@/components/base/Breadcrumb";
import FeedbackForm from "@/pages/about/components/FeedbackForm";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { siteAbout } from "@/mocks/site";

export default function About() {
  useDocumentTitle(
    "关于我们 - 杨幂明星资讯平台",
    "了解杨幂明星资讯平台的定位、内容介绍、使用说明与联系方式，欢迎通过反馈表单与我们联系。",
    "关于杨幂资讯站,杨幂资讯平台,杨幂联系方式",
  );

  return (
    <div className="w-full px-4 md:px-8 py-8 md:py-12">
      <Breadcrumb items={[{ label: "首页", path: "/" }, { label: "关于我们" }]} />

      <section className="mt-6 max-w-4xl">
        <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">{siteAbout.title}</h1>
        <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">{siteAbout.intro}</p>
      </section>

      <section className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
        {siteAbout.features.map((f) => (
          <div key={f.title} className="bg-background-50 border border-background-200 rounded-lg p-5 md:p-6">
            <span className="w-11 h-11 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center mb-4">
              <i className={`${f.icon} text-xl`} />
            </span>
            <h2 className="font-heading text-base md:text-lg font-bold text-foreground-950">{f.title}</h2>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
          </div>
        ))}
      </section>

      <section className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-10" id="contact">
        <div className="lg:col-span-5">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">联系方式</h2>
          <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{siteAbout.contact.note}</p>
          <div className="mt-6 space-y-4">
            <div className="flex items-center gap-3 bg-background-50 border border-background-200 rounded-lg p-4">
              <span className="w-10 h-10 rounded-lg bg-accent-100 text-accent-900 flex items-center justify-center shrink-0">
                <i className="ri-mail-line text-lg" />
              </span>
              <div>
                <p className="text-xs text-foreground-500 font-label">邮箱</p>
                <p className="text-sm text-foreground-900">{siteAbout.contact.email}</p>
              </div>
            </div>
            <div className="flex items-center gap-3 bg-background-50 border border-background-200 rounded-lg p-4">
              <span className="w-10 h-10 rounded-lg bg-accent-100 text-accent-900 flex items-center justify-center shrink-0">
                <i className="ri-weibo-line text-lg" />
              </span>
              <div>
                <p className="text-xs text-foreground-500 font-label">微博</p>
                <p className="text-sm text-foreground-900">{siteAbout.contact.weibo}</p>
              </div>
            </div>
          </div>

          <h2 className="mt-10 font-heading text-xl md:text-2xl font-bold text-foreground-950">使用说明</h2>
          <ul className="mt-4 space-y-3">
            {siteAbout.usage.map((u, idx) => (
              <li key={idx} className="flex items-start gap-3 text-sm text-foreground-600 leading-relaxed">
                <span className="w-6 h-6 rounded-full bg-secondary-100 text-secondary-900 flex items-center justify-center text-xs font-label shrink-0 mt-0.5">
                  {idx + 1}
                </span>
                {u}
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-7">
          <FeedbackForm />
        </div>
      </section>
    </div>
  );
}